import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiPromptAudit } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-ai-feedback-actions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ai-feedback-actions.component.html',
  styleUrl: './ai-feedback-actions.component.css',
})
export class AiFeedbackActionsComponent {
  @Input() audit: AiPromptAudit | null = null;
  @Output() auditRequested = new EventEmitter<AiPromptAudit>();

  openAudit(): void {
    if (!this.audit) return;
    this.auditRequested.emit(this.audit);
  }
}
